// @flow
import React, { type Element } from 'react';
import { Container, Tabs } from 'components';

const UserEdit: Function = (): Element<*> => {
  return (
    <Container.Tab>
      <Tabs />
    </Container.Tab>
  );
};

export default UserEdit;
